import React, { useEffect, useState } from "react";
import { Section } from "../../../../component/section";
import { CART_ICONS } from "../../interfaces/icon";
import { Box } from "zmp-ui";
import "./style.scss";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { deliveryInfoState } from "state";

export const OrderNote = () => {
  const { notes } = useRecoilValue(deliveryInfoState);
  const setDeliveryInfo = useSetRecoilState(deliveryInfoState);

  const [remainingChars, setRemainingChars] = useState(0);
  const orderStatus = "pending";

  useEffect(() => {
    setRemainingChars(notes?.length || 0);
  }, [notes]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setDeliveryInfo((prev) => ({ ...prev, notes: newValue }));
    setRemainingChars(newValue.length);
  };

  return (
    <Section title={"Ghi chú đơn hàng"} icon={CART_ICONS.note}>
      {orderStatus === "pending" ? (
        <Box>
          <div className="textarea-container">
            <textarea
              placeholder="Nhập ghi chú..."
              value={notes}
              maxLength={255}
              onChange={handleChange}
              style={{ width: "100%", height: "128px" }}
            />
            <span className="char-count">{remainingChars}/255</span>
          </div>
        </Box>
      ) : (
        <Box>
          <Box className="textarea-container">
            <textarea
              disabled="disabled"
              value={notes}
              maxLength={255}
              onChange={handleChange}
              style={{ width: "100%", height: "128px" }}
            />
            <span className="char-count">{remainingChars}/255</span>
          </Box>
        </Box>
      )}
    </Section>
  );
};
